<template>
  <main>
    <section v-show="visible">
      <div id="headerSection" class="whiteBackground text-center p-3">
        <b-row class="mt-2 mb-4">
          <b-col cols="12">
            <h4 class="myStudiesHeader ">
              <span style="cursor: pointer" @click="switchMode">My Study-Sites |</span>
              <span style="color: #00004E;"> All Study-Sites</span>
            </h4>
          </b-col>
        </b-row>
        <b-form @submit="onSubmit">
          <b-form-group>
            <b-container>
              <b-row class="mb-2 justify-content-center">
                <b-col cols="6">
                  <b-input
                    id="study-input"
                    v-model="filters.studyId"
                    :disabled="busy"
                    class="filterClass"
                    placeholder="Filter by Study ID"
                    type="search"
                  ></b-input>
                </b-col>
              </b-row>

              <b-row class="justify-content-center">
                <b-col cols="6">
                  <b-input
                    id="site-input"
                    v-model="filters.siteId"
                    :disabled="busy"
                    class="filterClass"
                    placeholder="Filter by Site"
                    type="search"
                  ></b-input>
                </b-col>
              </b-row>
              <b-row class="justify-content-center">
                <b-col>
                  <div class="mt-3">
                    <b-form-checkbox
                      v-model="filters.showCompleted"
                      :disabled="busy"
                      :unchecked-value="0"
                      :value="1"
                      switch
                      >Include Completed Study Site
                    </b-form-checkbox>
                  </div>
                </b-col>
              </b-row>

              <b-button :disabled="busy" class="mt-2" type="submit" variant="primary"
                >Filter
              </b-button>
              <b-button :disabled="busy" class="mt-2" variant="danger" @click="reset"
                >Clear
              </b-button>
            </b-container>
          </b-form-group>
        </b-form>
      </div>
      <b-container id="tableSection" class="mt-2 mb-4">
        <b-table
          id="sites-table"
          ref="siteTable"
          :busy.sync="busy"
          :current-page="currentPage"
          :fields="studySitesFields()"
          :items="tableItems"
          :per-page="perPage"
          empty-text="There are no study-sites available right now."
          responsive
          show-empty
          table-class="cardTable text-center"
          tbody-tr-class="tBodyTrClass"
          tdClass="tdClassAlignCenter"
          thClass="thClass"
          thead-class="thCustomClass"
          @row-clicked="viewSite"
        >
          <template #table-caption>
            <b-container>
              <b-row>
                <b-col
                  ><p v-if="tableItems" style="font-size: 16px">
                    <strong>{{ totalRows }}</strong>
                    {{ totalRows > 1 && totalRows !== 0 ? 'Study Sites' : 'Study Site' }}
                  </p></b-col
                >
                <b-col>
                  <span>
                    <label for="perPageSelector">Per page:</label>
                    <b-dropdown
                      id="perPageSelector"
                      :text="perPage.toString()"
                      variant="outline-secondary"
                    >
                      <b-dropdown-item style="pointer-events: none; opacity: 0.6"
                        >-- Select an option: --
                      </b-dropdown-item>
                      <b-dropdown-item
                        v-for="(item, idx) in perPageOptions"
                        :key="idx"
                        @click="perPage = item"
                        >{{ item }}
                      </b-dropdown-item>
                    </b-dropdown>
                  </span></b-col
                >
                <b-col>
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    align="center"
                    aria-controls="sites-table"
                    pills
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-container>
          </template>
          <template #table-busy>
            <div class="text-center text-secondary my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #head()="data">
            <div class="text-nowrap">
              {{ data.label }}
            </div>
          </template>
          <template #cell(site)="row">
            <p class="studySiteText mb-0">
              {{ row.item.studyInfo['studyID'] }} - {{ row.item.siteInfo['siteNumber'] }}
            </p>
          </template>
          <template #cell(actions)="row">
            <b-button class="mr-2" variant="link" @click="viewSite(row.item)">
              <b-img :src="actionArrow"></b-img>
            </b-button>
          </template>
          <template #cell(details)="row">
            <b-button variant="link" @click="row['toggleDetails']">
              <b-img :src="row['detailsShowing'] ? arrowUpCircle : arrowDownCircle"></b-img>
            </b-button>
          </template>
          <template #cell(siteInfo.simplifySiteStatus)="row">
            <status :status="row.item['siteInfo']['simplifySiteStatus']" />
          </template>
          <template #cell(siteEnrollmentData.randomized)="row">
            <strong>{{ randomized(row.item) }}</strong>
          </template>
          <template #row-details="row">
            <site-table-details :row="row.item" is-enrollment-oversight />
          </template>
        </b-table>
      </b-container>
    </section>

    <div v-show="!visible">
      <router-view :sites="tableItems" :user="user"></router-view>
    </div>
  </main>
</template>
<script>
  import actionArrow from '../../../images/actionArrow.png';
  import arrowUpCircle from '../../../images/arrowUpCircle.png';
  import arrowDownCircle from '../../../images/arrowDownCircle.png';
  import tableFieldsMixin from '.././mixins/tableFieldsMixin';
  import SiteTableDetails from '.././common/SiteTableDetails';
  import Status from '../common/Status';

  export default {
    name: 'enrollment-oversight',
    components: { SiteTableDetails, Status },
    mixins: [tableFieldsMixin],
    props: {
      user: Object,
    },
    metaInfo() {
      let metaTitle = this.$appName + 'Study-Sites';
      return {
        title: metaTitle,
      };
    },
    data() {
      return {
        actionArrow: actionArrow,
        arrowUpCircle: arrowUpCircle,
        arrowDownCircle: arrowDownCircle,
        tableItems: [],
        busy: false,
        perPage: 10,
        currentPage: 1,
        totalRows: 0,
        visible: false,
        filters: {
          studyId: '',
          siteId: '',
          showCompleted: 0,
        },
        perPageOptions: [5, 10, 15, 20],
      };
    },
    computed: {
      useSimAssociationsVersion() {
        if (Object.keys(this.$route.query).includes('useSimAssociationsVersion')) {
          return this.$route.query['useSimAssociationsVersion'] === 'true';
        }
        return window['Laravel']['feature_flags']['useSimAssociationsVersion'];
      },
      requestedStatuses() {
        return this.filters.showCompleted === 1
          ? 'Ongoing,Selected,Activated,Completed'
          : 'Ongoing,Selected,Activated';
      },
    },
    created() {
      this.setupHomepage();
    },
    watch: {
      $route() {
        this.visible = this.$route.name === 'studies';
      },
    },
    methods: {
      randomized(item) {
        let acceptedStatuses = ['ONGOING', 'ACTIVATED', 'COMPLETED'];
        if (
          Object.keys(item).length > 0 &&
          acceptedStatuses.includes(item['siteInfo']['simplifySiteStatus'].toUpperCase()) &&
          'siteEnrollmentData' in item
        ) {
          return item['siteEnrollmentData']['randomized'];
        } else {
          return 'N/A';
        }
      },
      setupHomepage() {
        this.visible = this.$route.name === 'studies';
        if (!this.visible) {
          this.filters = {
            studyId: this.$route.params.studyId,
            siteId: this.$route.params.siteId,
            showCompleted: 1,
          };
        }
        this.getSites();
      },
      viewSite(selected) {
        this.$router.push({
          name: 'site-summary',
          params: {
            siteId: selected['siteInfo']['siteNumber'],
            studyId: selected['studyInfo']['studyID'],
          },
        });
      },
      onSubmit() {
        event.preventDefault();
        this.getSites();
      },
      async getSites() {
        this.tableItems = [];
        this.totalRows = 0;
        try {
          this.busy = true;
          let params = {
            module: 'Enrollment Oversight',
            use_sim_associations_version: this.useSimAssociationsVersion ? 1 : 0,
          };
          if (this.filters.studyId) {
            params['study_like'] = this.filters.studyId;
          }
          if (this.filters.siteId) {
            params['site_number_like'] = this.filters.siteId;
          }
          params['status'] = this.requestedStatuses;
          let response = await axios.get(`/api/get-enrollment-oversight-sites`, {
            params: params,
          });
          if (response.status !== 204) {
            // if (this.filters.showCompleted === 1) {
            //   this.tableItems = response.data['items'].filter(el =>
            //     ['SELECTED', 'ONGOING', 'ACTIVATED', 'COMPLETED'].includes(
            //       el['siteInfo']['simplifySiteStatus'],
            //     ),
            //   );
            // } else {
            this.tableItems = response.data['items'];
            this.totalRows = this.tableItems.length;
            // }
          }
        } catch (error) {
          console.error(error);
        }
        this.busy = false;
      },
      reset() {
        this.filters = {
          studyId: '',
          siteId: '',
          showCompleted: 0,
        };
        this.getSites();
      },
      switchMode() {
        this.$emit('switch-mode', 'my-study-sites');
      },
    },
  };
</script>

<style scoped>
  .filterClass {
    height: 45px;
    background: #f4eff4;
    border-radius: 24px;
  }
</style>
